module.exports = __webpack_public_path__ + "static/media/MT.b2e21cf2.png";